module.exports = __webpack_public_path__ + "img/calendar2-month-fill.7a87a412.svg";